import React, { useState } from 'react';
import { signIn } from '../../actions/authActions';
import { connect } from 'react-redux';
import { NavLink, Navigate } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';
import '@animxyz/core';
import { XyzTransition } from '@animxyz/react';

function SignIn(props) {
  let initialState = { email: '', password: '' };
  const [state, setState] = useState(initialState);
  const [passIsVisible, setPassIsVisible] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.signIn(state);
  };

  const { uid } = props;
  if (uid) return <Navigate to='/' />;

  return (
    <Container className='connexion wrapper mt-5'>
      <XyzTransition appear xyz='fade flip-down stagger delay-4 duration-15'>
        <legend>
          <h3 className='d-flex justify-content-center'>Connexion</h3>
        </legend>
      </XyzTransition>
      <XyzTransition
        appear
        xyz='fade small out-down delay-2 duration-10 appear-stagger ease-out-back'
      >
        <Form autoComplete='off' onSubmit={handleSubmit}>
          <Form.Group controlId='email'>
            <Form.Label>Email:</Form.Label>
            <div className='input-group mb-3'>
              <Form.Control
                type='email'
                name="email"
                value={state.email}
                required
                autoComplete='off'
                onChange={handleChange}
                className='form-control'
              />
            </div>
          </Form.Group>
          <Form.Group controlId='password'>
            <Form.Label>Mot de passe:</Form.Label>
            <div className='input-group mb-3'>
              <Form.Control
                type={passIsVisible ? 'text' : 'password'}
                name="password"
                value={state.password}
                required
                autoComplete='off'
                onChange={handleChange}
              />
              <span
                className='input-group-text material-icons material-symbols-outlined'
                style={{ cursor: 'pointer' }}
                onClick={() => setPassIsVisible(!passIsVisible)}
              >
                {passIsVisible ? 'visibility' : 'visibility_off'}
              </span>
            </div>
          </Form.Group>
          <Button type='submit' variant='primary' className='submit mt-1'>
            Connexion
          </Button>
          <p className='d-flex justify-content-between mt-2'>
            <NavLink to='/motdepassereset' className='log-out'>
              Mot de passe oublié ?
            </NavLink>
            <NavLink to='/inscription' className='log-in'>
              Pas encore inscrit ?
            </NavLink>
          </p>
        </Form>
      </XyzTransition>
    </Container>
  );
}

const mapStateToProps = (state) => {
  const uid = state.firebase.auth.uid;
  return {
    uid: uid
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
